// extracted by mini-css-extract-plugin
export default {"overviewSVG":"ActionProviderDocs_overviewSVG__hfW0f","infoBoxParagraph":"ActionProviderDocs_infoBoxParagraph__Hen1d"};